_ = require 'underscore'
Dates = require 'app/scripts/lib/dates'
babble = require 'app/scripts/lib/babble'
f = require 'effing'
assert = require 'app/scripts/lib/assert'
{ logError } = require 'app/scripts/debug/log-error'
strings =
  action: require('locale').actions
  notification: require('locale').notifications
  notificationsGrouped: require('locale').notificationsGrouped
isTrelloAttachment = require 'app/scripts/lib/util/url/is-trello-attachment'
isTrello = require 'app/scripts/lib/util/url/is-trello'
isUrl = require 'app/scripts/lib/util/url/is-url'
{ siteDomain } = require '@trello/config'

makeTextEntity = (text, idContext, hideIfContext = false) ->
  { type: 'text', text, hideIfContext, idContext }

entityListVisitor = babble.makeVisitor makeTextEntity, (key, display) ->
  display.entities[key]

stringVisitor = babble.makeVisitor f.id, (key, subs) ->
  if subs.hasOwnProperty(key)
    subs[key]
  else
    logError(new Error("substitution key #{key} not found!"))
    ""

makeEntityFriendly = (entity) ->
  if !entity.url && (entity.urlContext || isUrl(entity.text))
    entity.url = entity.urlContext || entity.text
    entity.isFriendly = true

    if entity.type == 'text'
      entity.type = 'attachment'

  if entity.url?
    entity.isTrelloAttachment = isTrelloAttachment(entity.url)
    entity.isTrello = isTrello(entity.url)

  entity

# Common info our views expect to be part of 'display'
withAdditionalInfo = (entityIn) ->
  entity = _.clone(entityIn)
  # There's no proper library for getting short links right now, and we would
  # prefer not to refer to controller here. This should be fixed as soon as
  # we have a shortlink lib.
  switch entity.type
    when 'card' then entity.url = "#{siteDomain}/c/#{entity.shortLink ? entity.id}"
    when 'board' then entity.url = "#{siteDomain}/b/#{entity.shortLink ? entity.id}"
    when 'organization' then entity.url = "#{siteDomain}/#{entity.name ? entity.id}"
    when 'enterprise' then entity.url = "#{siteDomain}/e/#{entity.name ? entity.id}/admin/teams"
    when 'attachment' then makeEntityFriendly(entity)
    when 'text' then makeEntityFriendly(entity)

  entity

applyTo = (type, fn) -> (entity) ->
  if entity.type == type
    fn(entity)
  else
    entity

addUrlContext = (entities, urlContext) ->
  _.each entities, (entity) ->
    if entity.type == 'text' && !entity.idContext && urlContext
      entity.urlContext = urlContext

  entities

module.exports = class EntityDisplay
  constructor: (@type) ->
    @visit = f(babble.visit, strings[@type])

  translationKeys: (display, idContext) ->
    # FIX ME: this hack for changing the string key
    # for removing due date on a card. Normally this would be
    # provided by the server, so once this is fixed serverside,
    # we should remove this condition
    # cache the variable here to 'break' the reference to the original object.
    translationKey = display.translationKey
    if translationKey == 'notification_changed_due_date' && \
      display.entities.card?.due == null && \
      @type == 'notificationsGrouped'
        translationKey = 'notification_removed_due_date'
    # We also manually provide a date entity for use in the string keys
    if translationKey in ['notification_changed_due_date', 'notification_added_a_due_date']
      display.entities.date = {
        type: 'date'
        text: Dates.getDateDeltaString(display.entities.card.due, new Date())
        date: display.entities.card.due
      }

    nonContextKeys = [translationKey]
    if !idContext?
      return nonContextKeys

    matchingPair = _.find _.pairs(display.entities), ([type, entity]) ->
      entity.id == idContext

    if matchingPair?
      matchingType = matchingPair[0]
      [[translationKey, matchingType].join('@'), nonContextKeys...]
    else
      nonContextKeys

  # Converts a 'display' object to a localized list of 'entity' objects
  getEntities: (display, idContext) ->
    if display.translationKey == 'unknown'
      return []

    urlContext = _.find(display.entities, (({ type }) -> type in ['attachment', 'attachmentPreview']))?.originalUrl

    entityList = _.chain @translationKeys(display, idContext)
    .map (key) => @visit(key, entityListVisitor, display)
    .compact()
    .first()
    .tap (entities) => addUrlContext(entities, urlContext)
    .value()

    if !entityList?
      logError(new Error("display key '#{display.translationKey}' not found!"))
      return []

    entityList
    .map applyTo('translatable', @_textFromTranslatable.bind(@))
    .map applyTo('relDate', @_localizedRelDate.bind(@))
    .map withAdditionalInfo

  _format: (key, subs = {}) ->
    @visit(key, stringVisitor, subs).join('')

  # Takes a translatable and returns its translation in this context
  _textFromTranslatable: (entity) ->
    text = @_format(entity.translationKey)
    makeTextEntity(text, entity.idContext, entity.hideIfContext)

  # Replaces entity.current from the server with a localized version
  _localizedRelDate: (entity) ->
    _.defaults({ current: @relDateText(entity.date) }, entity)

  # Generate the localized message for a relDate entity
  # Exposed so that the client can update relative dates as time progresses
  relDateText: (dateStr, now = new Date()) ->
    date = new Date(dateStr)
    period = Dates.getDateDeltaString(date, now)
    relDateKey = if date > now
      'notification_is_due'
    else
      'notification_was_due'
    @_format(relDateKey, { period })
